import { render, staticRenderFns } from "./potencial-servicos.vue?vue&type=template&id=4c4c977c&scoped=true&"
import script from "./potencial-servicos.vue?vue&type=script&lang=js&"
export * from "./potencial-servicos.vue?vue&type=script&lang=js&"
import style0 from "./potencial-servicos.vue?vue&type=style&index=0&id=4c4c977c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4c977c",
  null
  
)

export default component.exports